import styled from 'styled-components';

export const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 400px;
  padding: 20px;
`;
export const FormContent = styled.div``;
